import {
  AsyncValidatorFn,
  AbstractControl,
  ValidationErrors,
} from '@angular/forms';
import { BaseApiService } from '@carm/_core/baseapi.service';
import { Injector, Injectable } from '@angular/core';
import { Observable, of, timer } from 'rxjs';
import { map, catchError, switchMap } from 'rxjs/operators';
import { ErrorCodes } from '@carm/_utils/error-handler/validations/error-code.mapper';
import { RoutesConst } from '@carm/shared/constants/const-routes';
import { DeclarationsService } from './declarations.service';
import { CadMetadataService } from '@carm/_core/declarations/services/cad-metadata.service';
import { CarmRouter } from '@carm/_core/carm-router/services/carm-router.service';

@Injectable()
export class DeclarationsAsyncValidatorsService extends BaseApiService {
  constructor(
    protected injector: Injector,
    private cadMetadataService: CadMetadataService,
    private declarationService: DeclarationsService,
    private router: CarmRouter
  ) {
    super(injector);
  }

  classificationNumberValidator(releaseData?: string): AsyncValidatorFn {
    return (control: AbstractControl): Observable<ValidationErrors | null> => {
      return timer(0).pipe(
        switchMap(() => {
          if (control.value) {
            return this.cadMetadataService
              .getClassificationCodeDetail(control.value, releaseData)
              .pipe(
                map(response => {
                  return response ? null : ErrorCodes.InvalidCode;
                }),
                catchError(_ => of(ErrorCodes.InvalidCode))
              );
          } else {
            return of(null);
          }
        })
      );
    };
  }

  b3transactionIdValidator(transactionId: string): AsyncValidatorFn {
    return (control: AbstractControl): Observable<ValidationErrors | null> => {
      return timer(0).pipe(
        switchMap(() =>
          this.declarationService.convertB3(control.value).pipe(
            map(response => {
              if (response.responseStatus === 'SUCCESS') {
                this.router.carmNavigate([
                  RoutesConst.Declarations_ConvertB3_SelectType,
                  transactionId,
                  response.draftUid,
                ]);
                return null;
              } else {
                return ErrorCodes.B3NotFound;
              }
            }),
            catchError(_ => of(ErrorCodes.B3NotFound))
          )
        )
      );
    };
  }
}
